import { useList, CrudFilter } from '@refinedev/core';

import { ScenarioUnifiedMitigation } from './../types';

export const MITIGATION_TYPE_IDS = [5];
export const DETECTION_RULE_TYPE_IDS = [1, 2, 3];

export const useScenarioUnifiedMitigations = (
  scenarioId: string | undefined,
  show_mitigations: boolean,
  show_detection_rules: boolean
) => {
  if (scenarioId === undefined) {
    return {
      scenarioMitigationsQuery: { data: [], isLoading: false, isError: false, refetch: () => Promise.resolve() }
    };
  }

  const filters: CrudFilter[] = [];

  filters.push({ field: 'scenario', operator: 'eq', value: scenarioId });

  if (show_mitigations && !show_detection_rules) {
    filters.push({ field: 'unifiedmitigationtype_in', operator: 'eq', value: MITIGATION_TYPE_IDS.join(',') });
  } else if (show_detection_rules && !show_mitigations) {
    filters.push({ field: 'unifiedmitigationtype_in', operator: 'eq', value: DETECTION_RULE_TYPE_IDS.join(',') });
  }

  const migratedScenarioMitigationsQuery = useList<ScenarioUnifiedMitigation>({
    resource: 'scenario_unified_mitigations',
    pagination: { pageSize: 10000 },
    filters,
    sorters: [{ field: 'order', order: 'asc' }]
  });

  const scenarioMitigationsQuery = {
    ...migratedScenarioMitigationsQuery.result,
    ...migratedScenarioMitigationsQuery.query,
    ...migratedScenarioMitigationsQuery
  };

  return { scenarioMitigationsQuery };
};
